(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3244],{

/***/ 63848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ idea_card_IdeaCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/providers/hooks/useActivity.ts
var useActivity = __webpack_require__(8565);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/cards/BaseCard.tsx
var BaseCard = __webpack_require__(46039);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
;// CONCATENATED MODULE: ./src/hooks/useFinishedLoading.ts


function useFinishedLoading() {
    var finished = (0,react.useRef)(false);
    var profile = (0,useProfile/* default */.Z)().profile;
    (0,react.useEffect)(function() {
        if (profile) {
            finished.current = true;
        }
    }, [
        profile
    ]);
    return finished.current;
}

// EXTERNAL MODULE: ./src/components/idea-card/components/FlipCorner.module.scss
var FlipCorner_module = __webpack_require__(11706);
var FlipCorner_module_default = /*#__PURE__*/__webpack_require__.n(FlipCorner_module);
;// CONCATENATED MODULE: ./src/components/idea-card/components/FlipCorner.tsx







var FLIP_CORNER_EDGE_SIZE_BASE = "1.5rem";
var FLIP_CORNER_EDGE_SIZE_LG = "2rem";
var FlipCorner = function(param) {
    var id = param.id, foldedRadiusSize = param.foldedRadiusSize, isNotInteractable = param.isNotInteractable;
    var ref;
    var invertedColorMode = (0,esm.useColorMode)().invertedColorMode;
    var activity = (0,useActivity/* default */.Z)().activity;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var savedAndInteractible = !isNotInteractable && isLoggedIn && (activity === null || activity === void 0 ? void 0 : (ref = activity.stashedIdeasIds) === null || ref === void 0 ? void 0 : ref.includes(id));
    var finished = useFinishedLoading();
    var ref1 = (0,react.useState)(savedAndInteractible ? (FlipCorner_module_default()).initial_saved_bottom_left : (FlipCorner_module_default()).initial_unsaved_bottom_left), flipCornerBottomLeft = ref1[0], setFlipCornerBottomLeft = ref1[1];
    var ref2 = (0,react.useState)(savedAndInteractible ? (FlipCorner_module_default()).initial_saved_top_right : (FlipCorner_module_default()).initial_unsaved_top_right), flipCornerTopRight = ref2[0], setFlipCornerTopRight = ref2[1];
    (0,react.useEffect)(function() {
        if (finished) {
            setFlipCornerBottomLeft(savedAndInteractible ? (FlipCorner_module_default()).saved_bottom_left : (FlipCorner_module_default()).unsaved_bottom_left);
            setFlipCornerTopRight(savedAndInteractible ? (FlipCorner_module_default()).saved_top_right : (FlipCorner_module_default()).unsaved_top_right);
        }
    }, [
        savedAndInteractible
    ]);
    var getClipPath = function(size) {
        return "polygon(0% 0, 0 0%, calc(100% - ".concat(size, ") 0%, 100% ").concat(size, ", 100% 100%, 100% 100%, 0 100%, 0 100%);");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: "1",
        width: {
            base: FLIP_CORNER_EDGE_SIZE_BASE,
            lg: FLIP_CORNER_EDGE_SIZE_LG
        },
        height: {
            base: FLIP_CORNER_EDGE_SIZE_BASE,
            lg: FLIP_CORNER_EDGE_SIZE_LG
        },
        // We cut from the top-right corener from the card when saved
        clipPath: {
            base: savedAndInteractible ? getClipPath(FLIP_CORNER_EDGE_SIZE_BASE) : "",
            lg: savedAndInteractible ? getClipPath(FLIP_CORNER_EDGE_SIZE_LG) : ""
        },
        children: [
            savedAndInteractible && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                w: "100%",
                h: "100%",
                position: "absolute",
                borderTopRightRadius: "1.25rem",
                className: flipCornerTopRight
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                w: "100%",
                h: "100%",
                backgroundColor: esm.color[invertedColorMode].underground,
                position: "absolute",
                borderBottomLeftRadius: foldedRadiusSize || "1rem",
                className: flipCornerBottomLeft
            })
        ]
    });
};
/* harmony default export */ var components_FlipCorner = (FlipCorner);

// EXTERNAL MODULE: ./src/hooks/useLocation.ts
var useLocation = __webpack_require__(8022);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/providers/hooks/useOwnIdea.ts
var useOwnIdea = __webpack_require__(11256);
// EXTERNAL MODULE: ./src/providers/hooks/useSourceEditor.ts + 1 modules
var useSourceEditor = __webpack_require__(44095);
;// CONCATENATED MODULE: ./src/components/idea-card/useIdeaCardInternals.ts






var useIdeaCardInternals = function(param) {
    var data = param.data;
    var source, idea;
    // typeof data === 'number' means that the idea belongs to the current user
    // don't make a boolean constant with this, because the build will fail on type checking
    var localIdeaId = typeof data === "number" ? data : -1;
    var ownIdea = (0,useOwnIdea/* default */.Z)(localIdeaId);
    var ref = (0,useSourceEditor/* default */.Z)(), sourceDispatch = ref.sourceDispatch, ideas = ref.ideas, providerSource = ref.source;
    var router = (0,next_router.useRouter)();
    if (typeof data === "number") {
        idea = ownIdea;
        source = providerSource;
    } else {
        idea = data.idea;
        source = data.source;
    }
    var path = router.asPath.split("/");
    var location = (0,useLocation/* default */.Z)();
    var idParam = path[2];
    var isIdeaOnArticlePage = location === "article" && idParam === (source === null || source === void 0 ? void 0 : source.id.toString());
    var profile = (0,useProfile/* default */.Z)().profile;
    var shouldIdeaBeTrimmed = location === "idea" && parseInt(router.query.id) !== (idea === null || idea === void 0 ? void 0 : idea.id);
    var userId = profile === null || profile === void 0 ? void 0 : profile.id;
    var headingSize = (0,react.useMemo)(function() {
        if (location === "idea" && parseInt(router.query.id) === (idea === null || idea === void 0 ? void 0 : idea.id)) return "h1";
        if (isIdeaOnArticlePage) return "h2";
        if (path[1] === "article" || path[1] === "profile" || path[1] === "") return "h4";
        if (path[1] === "u") return "h2";
        return "h3";
    }, [
        isIdeaOnArticlePage,
        path
    ]);
    //Set the draft state after a redirect with the edit param
    (0,react.useEffect)(function() {
        // only for own ideas
        if (typeof data === "number") {
            var editRedirect = !!router.query.edit && router.query.edit === (idea === null || idea === void 0 ? void 0 : idea.id.toString()) && (location === "article" || location === "idea");
            var canEdit = userId && (idea === null || idea === void 0 ? void 0 : idea.userId) === userId;
            if (editRedirect && canEdit && !(idea === null || idea === void 0 ? void 0 : idea.isDraft) && ideas.length !== 0) {
                sourceDispatch({
                    type: "toggle-is-idea-draft",
                    payload: {
                        localIdeaId: data
                    }
                });
            }
        }
    }, [
        ideas
    ]);
    return {
        headingSize: headingSize,
        shouldIdeaBeTrimmed: shouldIdeaBeTrimmed,
        idea: idea,
        source: source
    };
};

// EXTERNAL MODULE: ./src/components/image/NextImage.tsx + 11 modules
var NextImage = __webpack_require__(91260);
// EXTERNAL MODULE: ./src/components/idea-card/components/IdeaCard.module.scss
var IdeaCard_module = __webpack_require__(17630);
var IdeaCard_module_default = /*#__PURE__*/__webpack_require__.n(IdeaCard_module);
// EXTERNAL MODULE: ./src/components/idea-card/components/useIdeaCardContentUtils.ts
var useIdeaCardContentUtils = __webpack_require__(1650);
;// CONCATENATED MODULE: ./src/components/idea-card/components/IdeaCardContentImage.tsx











var IdeaCardContentImage = function(param) {
    var headingSize = param.headingSize, idea = param.idea, preloadImage = param.preloadImage, size = param.size, isNotInteractable = param.isNotInteractable, shouldTrim = param.shouldTrim, disableTitleHref = param.disableTitleHref;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var location = (0,useLocation/* default */.Z)();
    var image = idea.image, title = idea.title, imageBlurhash = idea.imageBlurhash;
    var ref = (0,react.useState)(), imageData = ref[0], setImageData = ref[1];
    // We no longer trim idea card content
    var ref1 = (0,useIdeaCardContentUtils/* useStylePropsForText */.z)(false, size, preloadImage), textSize = ref1.titleTextSize;
    var renderTitleText = function() {
        var renderedTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            type: "bold",
            size: headingSize
        }, textSize), {
            color: esm.color[colorMode].text,
            textAlign: "left",
            wordBreak: "break-word",
            marginBottom: isMobileView ? "0.5rem" : "1rem",
            children: title
        }));
        return !isLoggedIn && !disableTitleHref && (shouldTrim || location === "article" || location === "collection") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
            _hover: undefined,
            href: "/idea/".concat(idea.id, "/").concat((0,global/* slugify */.lV)(idea.title, idea.content)),
            children: renderedTitle
        }) : renderedTitle;
    };
    var imageWrapperStyle = {
        // The height is different depending on whether it's on mobile
        // or desktop, but it has no resize listener
        height: imageData ? isMobileView ? "calc(".concat(imageData.naturalHeight / imageData.naturalWidth, " * (100vw - 2rem))") : imageData.naturalHeight / imageData.naturalWidth * (0,global/* getPixelWidthFromColumns */.x$)(6) : "300px",
        width: "100%",
        position: "relative",
        borderTopRadius: "1rem",
        overflow: "hidden"
    };
    var renderIdeaImage = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
            nextImageProps: {
                onLoadingComplete: function(img) {
                    setImageData(img);
                }
            },
            wrapperStyle: imageWrapperStyle,
            imageUrl: image,
            alt: title,
            blurhash: imageBlurhash,
            priority: preloadImage,
            imageModal: "rect",
            isNotInteractable: isNotInteractable,
            imageClassName: (IdeaCard_module_default()).next_image_idea
        });
    }, [
        image,
        imageData,
        isNotInteractable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        h: "100%",
        flexDir: "column",
        flexGrow: 1,
        children: [
            renderIdeaImage(),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                px: {
                    base: "1.5rem",
                    lg: "2rem"
                },
                pt: {
                    base: "1rem",
                    lg: "1.5rem"
                },
                children: renderTitleText()
            })
        ]
    });
};
/* harmony default export */ var components_IdeaCardContentImage = (IdeaCardContentImage);

;// CONCATENATED MODULE: ./src/components/idea-card/IdeaCard.tsx















var IdeaCardActionBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1356).then(__webpack_require__.bind(__webpack_require__, 51356));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51356)
            ];
        }
    }
});
var IdeaCardContentQuote = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6887).then(__webpack_require__.bind(__webpack_require__, 96887));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96887)
            ];
        }
    }
});
var IdeaCardContentText = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6080).then(__webpack_require__.bind(__webpack_require__, 26080));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26080)
            ];
        }
    }
});
// eslint-disable-next-line react/display-name
var IdeaCard = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var ideaData = _param.ideaData, preloadImage = _param.preloadImage, onIdeaStashed = _param.onIdeaStashed, onIdeaUnstashed = _param.onIdeaUnstashed, isNotInteractable = _param.isNotInteractable, hideImage = _param.hideImage, disableTitleHref = _param.disableTitleHref, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ideaData",
        "preloadImage",
        "onIdeaStashed",
        "onIdeaUnstashed",
        "isNotInteractable",
        "hideImage",
        "disableTitleHref"
    ]);
    var _$ref;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var _$ref1 = useIdeaCardInternals({
        data: ideaData
    }), headingSize = _$ref1.headingSize, idea = _$ref1.idea, source = _$ref1.source, shouldIdeaBeTrimmed = _$ref1.shouldIdeaBeTrimmed;
    var activity = (0,useActivity/* default */.Z)().activity;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var saved = isLoggedIn && (activity === null || activity === void 0 ? void 0 : (_$ref = activity.stashedIdeasIds) === null || _$ref === void 0 ? void 0 : _$ref.includes((idea === null || idea === void 0 ? void 0 : idea.id) || -1));
    if (!idea) return null;
    var mainContainerStyling = (0,_object_spread/* default */.Z)({
        w: {
            base: "100%",
            md: (0,global/* getRemWidthFromColumns */._P)(4)
        },
        pos: "relative",
        // with no static pos (the default value), that's why IdeaCard should have pos: relative.
        borderRadius: "1.25rem",
        // borderTopRightRadius: saved ? '0' : '1.25rem',
        flexDir: "column",
        minH: esm.spacing.toRem(300),
        // We have this willChange prop to fix rendering issues on Safari
        willChange: "filter"
    }, props);
    var getClipPath = function(size) {
        return "polygon(0% 0, 0 0%, calc(100% - ".concat(size, ") 0%, 100% ").concat(size, ", 100% 100%, 100% 100%, 0 100%, 0 100%);");
    };
    var _backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mainContainerStyling), {
        "data-testid": "idea-card",
        className: "insight",
        id: "idea-".concat(idea.id),
        ref: ref
    }), props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseCard/* default */.Z, {
            pb: {
                base: "1rem",
                lg: "1.25rem"
            },
            flexDir: "column",
            justifyContent: "space-between",
            overflow: "hidden",
            flexGrow: 1,
            // We cut from the top-right corner of the card when saved
            clipPath: {
                base: !isNotInteractable && saved ? getClipPath(FLIP_CORNER_EDGE_SIZE_BASE) : "",
                lg: !isNotInteractable && saved ? getClipPath(FLIP_CORNER_EDGE_SIZE_LG) : ""
            },
            backgroundColor: (_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : esm.color[colorMode].top,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FlipCorner, {
                    id: idea.id,
                    isNotInteractable: isNotInteractable,
                    foldedRadiusSize: isMobileView ? "0.5rem" : "1rem"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    pos: "relative",
                    // Center the content if it's quote without image
                    height: idea.type === enums/* IdeaType.QUOTE */.Wm.QUOTE && !idea.image ? "100%" : "unset",
                    my: idea.type === enums/* IdeaType.QUOTE */.Wm.QUOTE ? "auto" : "unset",
                    children: idea.type === enums/* IdeaType.QUOTE */.Wm.QUOTE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaCardContentQuote, {
                        headingSize: headingSize,
                        idea: idea,
                        preloadImage: preloadImage,
                        isNotInteractable: isNotInteractable,
                        shouldTrim: shouldIdeaBeTrimmed,
                        disableTitleHref: disableTitleHref
                    }) : idea.type === enums/* IdeaType.DEFAULT */.Wm.DEFAULT ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaCardContentText, {
                        headingSize: headingSize,
                        idea: idea,
                        preloadImage: preloadImage,
                        isNotInteractable: isNotInteractable,
                        shouldTrim: shouldIdeaBeTrimmed,
                        hideImage: hideImage,
                        disableTitleHref: disableTitleHref
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IdeaCardContentImage, {
                        headingSize: headingSize,
                        idea: idea,
                        preloadImage: preloadImage,
                        isNotInteractable: isNotInteractable,
                        shouldTrim: shouldIdeaBeTrimmed,
                        hideImage: hideImage,
                        disableTitleHref: disableTitleHref
                    })
                }),
                !isNotInteractable && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    onClick: function(ev) {
                        return ev.stopPropagation();
                    },
                    px: {
                        base: "1.5rem",
                        lg: "2rem"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaCardActionBar, {
                        source: source,
                        onIdeaStashed: onIdeaStashed,
                        onIdeaUntashed: onIdeaUnstashed,
                        idea: idea
                    })
                })
            ]
        })
    }));
});
/* harmony default export */ var idea_card_IdeaCard = (IdeaCard);


/***/ }),

/***/ 1650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useStylePropsForQuote; },
/* harmony export */   "z": function() { return /* binding */ useStylePropsForText; }
/* harmony export */ });
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var useStylePropsForQuote = function(preloadImage, isIdeaTrimmed, size) {
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.useIsMobileView)();
    var imageSize = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        switch(size){
            case "sm":
                {
                    return "4rem";
                }
            default:
                {
                    if (isIdeaTrimmed) {
                        if (isMobileView) {
                            return "4.75rem";
                        } else {
                            return "6.25rem";
                        }
                    } else {
                        //Make the image 1 px taller to trick google =))
                        if (preloadImage) {
                            if (isMobileView) {
                                return "6.3125rem";
                            } else {
                                return "8.8125rem";
                            }
                        } else {
                            if (isMobileView) {
                                return "6.25rem";
                            } else {
                                return "8.75rem";
                            }
                        }
                    }
                }
        }
    }, [
        isIdeaTrimmed,
        isMobileView,
        preloadImage
    ]);
    var style = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        switch(size){
            case "sm":
                {
                    return {
                        imageSize: imageSize,
                        titleTextSize: {
                            textSize: "s",
                            fontSize: "1rem",
                            lineHeight: "1.5rem"
                        },
                        contentTextSize: deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.typography.primaryTextFonts.small.italic
                    };
                }
            default:
                {
                    /**
         * Default is md
         */ return {
                        imageSize: imageSize,
                        titleTextSize: {
                            textSize: "s"
                        },
                        contentTextSize: isMobileView || isIdeaTrimmed ? deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.typography.primaryTextFonts.medium.italic : deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.typography.primaryTextFonts.large.italic
                    };
                }
        }
    }, [
        size,
        isIdeaTrimmed,
        isMobileView
    ]);
    return style;
};
var useStylePropsForText = function(isIdeaTrimmed, size, preloadImage) {
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.useIsMobileView)();
    var imageHeight = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        switch(size){
            case "sm":
                {
                    return "5rem";
                }
            default:
                {
                    //Make the image 1 px taller to trick google =))
                    if (preloadImage) {
                        if (isMobileView) {
                            return "7.5625rem";
                        } else {
                            return "10.0625rem";
                        }
                    } else {
                        if (isMobileView) {
                            return "7.5rem";
                        } else {
                            return "10rem";
                        }
                    }
                }
        }
    }, [
        preloadImage,
        isMobileView,
        size
    ]);
    var style = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        switch(size){
            case "sm":
                {
                    return {
                        imageHeight: imageHeight,
                        titleTextSize: {
                            textSize: "s",
                            fontSize: "1rem",
                            lineHeight: "1.5rem"
                        },
                        contentTextSize: deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.typography.primaryTextFonts.small.regular
                    };
                }
            default:
                {
                    /**
         * default is md
         */ return {
                        imageHeight: imageHeight,
                        titleTextSize: {
                            textSize: isMobileView ? "s" : "m"
                        },
                        contentTextSize: isMobileView || isIdeaTrimmed ? deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.typography.primaryTextFonts.medium.regular : deepstash_ui__WEBPACK_IMPORTED_MODULE_0__.typography.primaryTextFonts.large.regular
                    };
                }
        }
    }, [
        isMobileView,
        size,
        isIdeaTrimmed
    ]);
    return style;
};


/***/ }),

/***/ 34549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ source_preview_SourcePreview; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/providers/hooks/useActivity.ts
var useActivity = __webpack_require__(8565);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/idea/useIsIdeaStashed.tsx


/**
 * TODO needs to be in a subfolder
 * @param id
 */ var useIsIdeaStashed = function(id) {
    var activity = (0,useActivity/* default */.Z)().activity;
    var currentSelectedStashId = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = activity === null || activity === void 0 ? void 0 : (ref = activity.stashedIdeas) === null || ref === void 0 ? void 0 : ref.find(function(x) {
            return x[0] === id;
        })) === null || ref1 === void 0 ? void 0 : ref1[1];
    }, [
        activity === null || activity === void 0 ? void 0 : activity.stashedIdeas,
        id
    ]);
    var isStashed = (0,react.useMemo)(function() {
        var ref;
        return ((ref = activity === null || activity === void 0 ? void 0 : activity.stashedIdeasIds.includes(id)) !== null && ref !== void 0 ? ref : false) && //If this is an idea the current user published without a stash, it will appear in the stashed ideas ids, but won't have a stash associated
        currentSelectedStashId !== undefined;
    }, [
        activity === null || activity === void 0 ? void 0 : activity.stashedIdeasIds,
        id
    ]);
    return isStashed;
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(98377);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/providers/reads-autoincrement/IntersectionObserverProvider.tsx
var IntersectionObserverProvider = __webpack_require__(7315);
// EXTERNAL MODULE: ./src/components/idea-card/IdeaCard.tsx + 4 modules
var IdeaCard = __webpack_require__(63848);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
;// CONCATENATED MODULE: ./src/components/source/source-preview/SourcePreviewMobile.tsx









// eslint-disable-next-line react/display-name
var SourcePreviewMobile = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var source = _param.source, ideaId = _param.ideaId, // cornerElement,
    // headerMode,
    onIdeaStashed = _param.onIdeaStashed, // onHeartLike,
    // onHeartUnlike,
    onIdeaUnstashed = _param.onIdeaUnstashed, preloadIdeaImage = _param.preloadIdeaImage, redirectToArticle = _param.redirectToArticle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "source",
        "ideaId",
        "onIdeaStashed",
        "onIdeaUnstashed",
        "preloadIdeaImage",
        "redirectToArticle"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var rootRef = (0,react.useRef)();
    var _$ref;
    var previewIdea = (0,react.useMemo)(function() {
        return (_$ref = source.ideas.find(function(idea) {
            return idea.id === ideaId;
        })) !== null && _$ref !== void 0 ? _$ref : source.ideas[0];
    }, [
        source,
        ideaId
    ]);
    var setInsights = (0,react.useContext)(IntersectionObserverProvider.IntersectionObserverContext).setInsights;
    (0,react.useEffect)(function() {
        setInsights([
            previewIdea
        ]);
    }, [
        previewIdea,
        setInsights
    ]);
    var imperativeHandleCbk = function() {
        return rootRef.current;
    };
    (0,react.useImperativeHandle)(ref, imperativeHandleCbk);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        gridColumn: "span 4 / span 4",
        position: "relative"
    }, props), {
        ref: function(el) {
            return rootRef.current = el !== null && el !== void 0 ? el : undefined;
        },
        px: "1rem",
        py: "1rem",
        onClick: redirectToArticle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                backgroundColor: esm.color[colorMode].surface,
                _hover: undefined,
                pos: "absolute",
                h: "calc(100% + 1rem)",
                w: "calc(100% + 2rem)",
                ml: "-1rem" //Cover the paddingLeft of the layout
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flexDir: "column",
                pb: 0,
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                        source: source,
                        size: "small"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaCard/* default */.Z, {
                        ideaData: {
                            idea: previewIdea,
                            source: source
                        },
                        onIdeaStashed: onIdeaStashed,
                        onIdeaUnstashed: onIdeaUnstashed,
                        // [Like functionality]
                        // onHeartLike={onHeartLike}
                        // onHeartUnlike={onHeartUnlike}
                        preloadImage: preloadIdeaImage,
                        pos: "relative"
                    })
                ]
            })
        ]
    }));
});
/* harmony default export */ var source_preview_SourcePreviewMobile = (SourcePreviewMobile);

;// CONCATENATED MODULE: ./src/components/source/source-preview/SourcePreview.tsx












var SourcePreviewDesktop = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7741).then(__webpack_require__.bind(__webpack_require__, 67741));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67741)
            ];
        }
    }
});
SourcePreviewDesktop.displayName = "SourcePreviewDesktop";
// eslint-disable-next-line react/display-name
var SourcePreview = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var sourceProp = _param.source, ideaId = _param.ideaId, cornerElement = _param.cornerElement, apiDataMutate = _param.apiDataMutate, _headerMode = _param.headerMode, headerMode = _headerMode === void 0 ? "stash" : _headerMode, props = (0,_object_without_properties/* default */.Z)(_param, [
        "source",
        "ideaId",
        "cornerElement",
        "apiDataMutate",
        "headerMode"
    ]);
    var _$ref;
    var isMobileView = (0,esm.useIsMobileView)();
    var router = (0,useRouter/* default */.Z)();
    var _$ref1 = (0,react.useState)(sourceProp), source = _$ref1[0], setSource = _$ref1[1];
    (0,react.useEffect)(function() {
        setSource(sourceProp);
    }, [
        sourceProp
    ]);
    var childRef = (0,react.useRef)();
    var imperativeHandleCbk = function() {
        return childRef.current;
    };
    (0,react.useImperativeHandle)(ref, imperativeHandleCbk);
    var redirectToArticle = (0,react.useCallback)(function(e) {
        var _$ref;
        var url = "/article/".concat(source.id, "/").concat((0,global/* slugify */.lV)(source.title));
        e.stopPropagation();
        var _$ref1;
        if (((_$ref1 = (_$ref = window.getSelection()) === null || _$ref === void 0 ? void 0 : _$ref.toString()) !== null && _$ref1 !== void 0 ? _$ref1 : "") === "" && url) {
            // the url we clicked on is valid
            if (e.metaKey === false || e.ctrlKey === false) {
                // we only left clicked
                // metaKey it's actually ctrlKey for the macintosh
                router.push(url);
            } else if (true) {
                var // we click + control ( + cmd on Safari )
                _$ref2;
                (_$ref2 = window.open(url, "_blank")) === null || _$ref2 === void 0 ? void 0 : _$ref2.focus();
            }
        }
    }, [
        source.title,
        source.id
    ]);
    //Increment the total stash count for the idea live
    var ideaToShowId = ideaId !== null && ideaId !== void 0 ? ideaId : (_$ref = source.ideas[0]) === null || _$ref === void 0 ? void 0 : _$ref.id;
    var isIdeaStashed = useIsIdeaStashed(ideaToShowId);
    var onIdeaStash = (0,react.useCallback)(function() {
        if (!isIdeaStashed) {
            setSource(function(prevSource) {
                //Increment the total stashed for the sown idea
                var ideaIndex = prevSource.ideas.findIndex(function(param) {
                    var id = param.id;
                    return id === ideaToShowId;
                });
                var ideas = (0,_to_consumable_array/* default */.Z)(prevSource.ideas);
                ideas[ideaIndex].totalSaves++;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevSource), {
                    ideas: ideas
                });
            });
        }
    }, [
        ideaToShowId,
        isIdeaStashed
    ]);
    var onIdeaUnstash = (0,react.useCallback)(function() {
        if (isIdeaStashed) {
            setSource(function(prevSource) {
                //Increment the total stashed for the sown idea
                var ideaIndex = prevSource.ideas.findIndex(function(param) {
                    var id = param.id;
                    return id === ideaToShowId;
                });
                var ideas = (0,_to_consumable_array/* default */.Z)(prevSource.ideas);
                ideas[ideaIndex].totalSaves--;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevSource), {
                    ideas: ideas
                });
            });
        }
    }, [
        ideaToShowId,
        isIdeaStashed
    ]);
    // [Like functionality]
    // const onHeartLike = useCallback(() => {
    //   setSource(prevSource => {
    //     const ideaIndex = prevSource.ideas.findIndex(
    //       ({ id }) => id === ideaToShowId,
    //     );
    //     const ideas = [...prevSource.ideas];
    //     ideas[ideaIndex].totalLikes++;
    //     return { ...prevSource, ideas };
    //   });
    // }, []);
    // const onHeartUnlike = useCallback(() => {
    //   setSource(prevSource => {
    //     const ideaIndex = prevSource.ideas.findIndex(
    //       ({ id }) => id === ideaToShowId,
    //     );
    //     const ideas = [...prevSource.ideas];
    //     ideas[ideaIndex].totalLikes--;
    //     return { ...prevSource, ideas };
    //   });
    // }, []);
    if (source.ideas.length === 0) {
        return null;
    }
    if (!source) return null;
    return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(source_preview_SourcePreviewMobile, (0,_object_spread/* default */.Z)({
        source: source,
        ideaId: ideaId,
        ref: ref,
        cornerElement: cornerElement,
        onIdeaStashed: onIdeaStash,
        onIdeaUnstashed: onIdeaUnstash,
        // [Like functionality]
        // onHeartLike={onHeartLike}
        // onHeartUnlike={onHeartUnlike}
        headerMode: headerMode,
        redirectToArticle: redirectToArticle
    }, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SourcePreviewDesktop, (0,_object_spread/* default */.Z)({
        redirectToArticle: redirectToArticle,
        source: source,
        ideaId: ideaId,
        cornerElement: cornerElement,
        headerMode: headerMode,
        onIdeaStashed: onIdeaStash,
        onIdeaUnstashed: onIdeaUnstash,
        // [Like functionality]
        // onHeartLike={onHeartLike}
        // onHeartUnlike={onHeartUnlike}
        apiDataMutate: apiDataMutate,
        ref: ref
    }, props));
});
/* harmony default export */ var source_preview_SourcePreview = (SourcePreview);


/***/ }),

/***/ 11256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useSourceEditor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44095);



/**
 * This hook handles getting ideas from a SourceProvider
 * It handles automatically subscribing and unsubscribing from Observables
 * It always returns the latest values of an idea
 * @param ideaId The key of the idea we want to use
 * @param defaultValue A fallback value in case no idea is found with that key
 */ var useOwnIdea = function(ideaId, defaultValue) {
    var ideas = (0,_useSourceEditor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().ideas;
    var observable = ideas.find(function(idea) {
        return idea.Data.localId === ideaId;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(observable === null || observable === void 0 ? void 0 : observable.Data), value = ref[0], setValue = ref[1];
    var subscriber = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newValue) {
        setValue((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, newValue));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observable = ideas.find(function(idea) {
            return idea.Data.localId === ideaId;
        });
        observable === null || observable === void 0 ? void 0 : observable.subscribe(subscriber);
        return function() {
            observable === null || observable === void 0 ? void 0 : observable.unsubscribe(subscriber);
        };
    }, [
        ideaId,
        ideas
    ]);
    return value !== null && value !== void 0 ? value : defaultValue;
};
/* harmony default export */ __webpack_exports__["Z"] = (useOwnIdea);


/***/ }),

/***/ 44095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useSourceEditor; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/providers/source/SourceEditorActions.ts
var SourceEditorActions = __webpack_require__(32425);
// EXTERNAL MODULE: ./src/providers/source/DraftProvider.tsx
var DraftProvider = __webpack_require__(57825);
// EXTERNAL MODULE: ./src/providers/source/SourceEditorReducer.ts
var SourceEditorReducer = __webpack_require__(24718);
;// CONCATENATED MODULE: ./src/providers/source/index.ts





// EXTERNAL MODULE: ./src/providers/hooks/useCreateContextConsumer.ts + 1 modules
var useCreateContextConsumer = __webpack_require__(75934);
;// CONCATENATED MODULE: ./src/providers/hooks/useSourceEditor.ts






var useSourceEditor = function() {
    var _ref = (0,useCreateContextConsumer/* default */.Z)({
        context: DraftProvider.DraftContext,
        asyncActions: SourceEditorActions,
        withLogging: true
    }), dispatch = _ref.dispatch, contextConsumer = (0,_object_without_properties/* default */.Z)(_ref, [
        "dispatch"
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contextConsumer), {
        sourceDispatch: dispatch
    });
};
/* harmony default export */ var hooks_useSourceEditor = (useSourceEditor);


/***/ }),

/***/ 7315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IntersectionObserverContext": function() { return /* binding */ IntersectionObserverContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_providers_hooks_useActivity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8565);
/* harmony import */ var src_providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2334);
/* harmony import */ var src_utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14531);
/* harmony import */ var src_utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var utils_collection_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85295);
/* harmony import */ var _hooks_useNsiActivity__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7964);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79139);











var IntersectionObserverContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.createContext)({
    setInsights: function() {
        return;
    }
});
var IntersectionObserverProvider = function(param) {
    var children = param.children;
    var markAsReadQueue = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)([]);
    var markAsReadTimeout = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(new src_utils_global__WEBPACK_IMPORTED_MODULE_4__/* .PausableTimeout */ .o6());
    var currentHighPriorityInsightId = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var isWindowBlured = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(false);
    var ideas = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)([]);
    var ref = (0,src_providers_hooks_useActivity__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), activity = ref.activity, activityDispatch = ref.activityDispatch;
    var ref1 = (0,_hooks_useNsiActivity__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), nsiActivityDispatch = ref1.nsiActivityDispatch, nsiReads = ref1.reads;
    var profile = (0,src_providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().profile;
    var isLoggedIn = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().isLoggedIn;
    var intersectionObserverOptions = {
        threshold: [
            0.2,
            0.6
        ],
        rootMargin: "0px"
    };
    var onWindowBlur = function() {
        isWindowBlured.current = true;
        markAsReadTimeout.current.pause();
    };
    var onWindowFocus = function() {
        isWindowBlured.current = false;
        markAsReadTimeout.current.resume();
    };
    var evaluateMarkAsReadQueue = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var dispatchRead = function() {
            var highPriorityId = currentHighPriorityInsightId.current;
            // We have profile?.department !== null -- to avoid reads from incrementing while you are in setup
            // Department is null only if you create a new account that has not completed the setup
            // Legacy accounts which didn't choose a department the value for the department is an empty string, not null
            // So we have all the cases covered
            if (highPriorityId && (profile === null || profile === void 0 ? void 0 : profile.department) !== null) {
                var callback = function(id) {
                    if (isLoggedIn) {
                        var ref;
                        activityDispatch({
                            type: "increment-read",
                            payload: {
                                ideaId: id,
                                readingGoal: (ref = profile === null || profile === void 0 ? void 0 : profile.dailyReadingGoal) !== null && ref !== void 0 ? ref : 0,
                                collectionId: (0,utils_collection_utils__WEBPACK_IMPORTED_MODULE_7__/* .getCollectionIdOnSourcePage */ .rX)()
                            }
                        });
                    } else {
                        nsiActivityDispatch({
                            type: "read-idea",
                            payload: {
                                ideaId: id
                            }
                        });
                    }
                    markAsReadQueue.current = markAsReadQueue.current.filter(function(val) {
                        return val.id !== currentHighPriorityInsightId.current;
                    });
                    currentHighPriorityInsightId.current = null;
                    evaluateMarkAsReadQueue();
                };
                var idea = ideas.current.find(function(val) {
                    return val.id === currentHighPriorityInsightId.current;
                });
                //Time to read can come as string from the api so we make the following assertion to decide the delay
                var delay = ((idea === null || idea === void 0 ? void 0 : idea.timeToRead) && Number.parseFloat(idea.timeToRead.toString()) !== 0 ? Number.parseFloat(idea.timeToRead.toString()) : src_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_READ_TIME */ .tM) * 1000;
                markAsReadTimeout.current.start(function() {
                    return callback(highPriorityId);
                }, delay);
                // Pause the timeout if it started with the window blurred
                if (isWindowBlured.current) markAsReadTimeout.current.pause();
            }
        };
        var priorityIdea = (0,src_utils_global__WEBPACK_IMPORTED_MODULE_4__/* .selectHighestPriorityIdea */ .H_)(markAsReadQueue.current);
        if (priorityIdea && (!currentHighPriorityInsightId.current || currentHighPriorityInsightId.current !== priorityIdea.id)) {
            markAsReadTimeout.current.stop();
            currentHighPriorityInsightId.current = priorityIdea.id;
            dispatchRead();
        }
    }, [
        isLoggedIn,
        profile === null || profile === void 0 ? void 0 : profile.department
    ]);
    var intersectionObserverCallback = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(entries) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var entry = _step.value;
                var ref;
                //The id is `idea-<id>`
                var ideaId = Number.parseInt(entry.target.id.substring(5));
                if (!(activity === null || activity === void 0 ? void 0 : (ref = activity.sessionReads) === null || ref === void 0 ? void 0 : ref.has(ideaId)) && !nsiReads.sessionReads.has(ideaId)) {
                    var ref1;
                    var idea = (ref1 = ideas.current) === null || ref1 === void 0 ? void 0 : ref1.find(function(val) {
                        return val.id === ideaId;
                    });
                    if (idea) {
                        var insightIndex = markAsReadQueue.current.findIndex(function(val) {
                            return val.id === ideaId;
                        });
                        if (entry.intersectionRatio >= 0.5) {
                            if (insightIndex === -1) {
                                // Check if you need to fetch images for ideas
                                markAsReadQueue.current.push(idea);
                                evaluateMarkAsReadQueue();
                            }
                        } else if (insightIndex !== -1 && !entry.isIntersecting) {
                            markAsReadQueue.current = markAsReadQueue.current.filter(function(val) {
                                return val.id !== ideaId;
                            });
                            evaluateMarkAsReadQueue();
                        }
                    }
                }
            };
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        activity === null || activity === void 0 ? void 0 : activity.sessionReads,
        nsiReads.sessionReads,
        evaluateMarkAsReadQueue
    ]);
    var setInsights = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(val) {
        //Update the IOContext in a timeout to give the UI time to update and have elements with the class of insight on screen
        setTimeout(function() {
            var //Don't let ideas without an id get added
            _current;
            var //The ideas change so register the dom elements to the IO
            ref;
            (_current = ideas.current).push.apply(_current, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(val.filter(function(idea) {
                return idea.id !== -1 && !ideas.current.find(function(val) {
                    return val.id === idea.id;
                });
            })));
            (ref = intersectionObserverRef.current) === null || ref === void 0 ? void 0 : ref.disconnect();
            registerToIntersectionObserver();
            //Cleanup the rest of the state
            currentHighPriorityInsightId.current = null;
            markAsReadQueue.current = [];
        }, 1000);
    }, []);
    //Clean up the ideas list
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var callback = function() {
            ideas.current = [];
        };
        next_router__WEBPACK_IMPORTED_MODULE_5__.Router.events.on("routeChangeStart", callback);
        return function() {
            next_router__WEBPACK_IMPORTED_MODULE_5__.Router.events.off("routeChangeStart", callback);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        intersectionObserverRef.current = new IntersectionObserver(intersectionObserverCallback, intersectionObserverOptions);
        registerToIntersectionObserver();
        return function() {
            var ref;
            markAsReadTimeout.current.stop();
            (ref = intersectionObserverRef.current) === null || ref === void 0 ? void 0 : ref.disconnect();
            currentHighPriorityInsightId.current = null;
            markAsReadQueue.current = [];
        };
    }, [
        intersectionObserverCallback
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        window.addEventListener("blur", onWindowBlur);
        window.addEventListener("focus", onWindowFocus);
        return function() {
            window.removeEventListener("blur", onWindowBlur);
            window.removeEventListener("focus", onWindowFocus);
        };
    }, []);
    var intersectionObserverRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var registerToIntersectionObserver = function() {
        var ref;
        markAsReadTimeout.current.stop();
        (ref = intersectionObserverRef.current) === null || ref === void 0 ? void 0 : ref.disconnect();
        var elements = document.querySelectorAll(".insight");
        elements.forEach(function(element) {
            var ref;
            return (ref = intersectionObserverRef.current) === null || ref === void 0 ? void 0 : ref.observe(element);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IntersectionObserverContext.Provider, {
        value: {
            setInsights: setInsights
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IntersectionObserverProvider);


/***/ }),

/***/ 57825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DraftContext": function() { return /* binding */ DraftContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40802);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13819);
/* harmony import */ var hooks_usePrevious__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60050);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var types_models__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82260);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var _SourceEditorActions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32425);
/* harmony import */ var _SourceEditorReducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24718);










var INITIAL_VALUE = {
    ideas: [],
    source: null,
    sourceContextEditorRef: undefined,
    sourceTitleEditorRef: undefined,
    sourceHashtags: [],
    validIdeasCount: 0
};
var DraftContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    dispatch: function() {
        return;
    },
    state: INITIAL_VALUE,
    extra: {
        isIdeaFocused: function() {
            return false;
        }
    }
});
DraftContext.displayName = "DraftContext";
var DraftProvider = function(param) {
    var source = param.draft, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useReducer)(_SourceEditorReducer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, INITIAL_VALUE)), state = ref[0], dispatch = ref[1];
    var prevSource = (0,hooks_usePrevious__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state.source);
    var prevSourceHashtags = (0,hooks_usePrevious__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state.sourceHashtags);
    var prevValidIdeasCount = (0,hooks_usePrevious__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state.validIdeasCount);
    // const { isOpen: isCelebrationModalOpen, onClose: onCelebrationModalClose } =
    //   useDisclosure();
    //Sync the props with the state
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        dispatch({
            type: "set-source",
            payload: {
                source: source
            }
        });
    }, [
        source === null || source === void 0 ? void 0 : source.id
    ]);
    var showPopup = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(e) {
        var unsavedIdeaCount = state.ideas.map(function(idea) {
            return idea.Data;
        }).reduce(function(acc, idea) {
            return idea.syncStatus !== types_models__WEBPACK_IMPORTED_MODULE_3__/* .IdeaSyncStatus.SYNCED */ .yv.SYNCED ? acc + 1 : acc;
        }, 0);
        //Sync the ideas before unload
        if (state.source) {
            var ref;
            (0,_SourceEditorActions__WEBPACK_IMPORTED_MODULE_5__.syncIdeas)(dispatch, {
                ideas: state.ideas.map(function(param) {
                    var Data = param.Data;
                    return Data;
                }),
                sourceId: (ref = state.source) === null || ref === void 0 ? void 0 : ref.id
            });
        }
        if (unsavedIdeaCount > 0) {
            e.preventDefault();
            e.stopPropagation();
            e.returnValue = "You have unstashed ideas";
        }
    }, [
        state.ideas
    ]);
    var isIdeaFocused = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(idea) {
        return !!idea && idea.localId === state.focusedDraft;
    }, [
        state.focusedDraft
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.addEventListener("beforeunload", showPopup);
        return function() {
            window.removeEventListener("beforeunload", showPopup);
        };
    }, [
        showPopup
    ]);
    // // Read auto-increment
    // const { setInsights } = useContext(IntersectionObserverContext);
    // useEffect(() => {
    //   if (state.source?.status !== ArticleStatus.DRAFT) {
    //     setInsights(state.ideas.map(idea => idea.Data));
    //   }
    // }, [state.source?.status, state.ideas, setInsights]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            dispatch: dispatch,
            state: state,
            extra: {
                isIdeaFocused: isIdeaFocused
            }
        };
    }, [
        dispatch,
        state,
        isIdeaFocused
    ]);
    // Logs
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        //Log the differences
        if (!prevSource || !state.source) {
            var _source;
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .addBreadcrumb */ .n_({
                data: (_source = state.source) !== null && _source !== void 0 ? _source : {
                    data: "Null source"
                },
                category: "source",
                level: _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .Severity.Log */ .z.Log,
                message: "Initial source ".concat(source === null || source === void 0 ? void 0 : source.id)
            });
            return;
        }
        var diff = (0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .getObjectDiff */ .d$)(state.source, prevSource);
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .addBreadcrumb */ .n_({
            data: diff,
            category: "source",
            level: _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .Severity.Log */ .z.Log,
            message: "Source updated ".concat(source === null || source === void 0 ? void 0 : source.id)
        });
    }, [
        state.source
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        //Log the differences
        if (prevSourceHashtags !== state.sourceHashtags) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .addBreadcrumb */ .n_({
                data: state.sourceHashtags,
                category: "source",
                level: _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .Severity.Log */ .z.Log,
                message: "Source hashtags updated ".concat(source === null || source === void 0 ? void 0 : source.id)
            });
        }
    }, [
        state.sourceHashtags
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (state.validIdeasCount !== prevValidIdeasCount) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .addBreadcrumb */ .n_({
                data: state.sourceHashtags,
                category: "source",
                level: _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .Severity.Log */ .z.Log,
                message: "Source hashtags updated ".concat(source === null || source === void 0 ? void 0 : source.id)
            });
        }
    }, [
        state.validIdeasCount
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DraftContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DraftProvider);


/***/ }),

/***/ 32425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteDraft": function() { return /* binding */ deleteDraft; },
/* harmony export */   "deleteIdea": function() { return /* binding */ deleteIdea; },
/* harmony export */   "syncIdea": function() { return /* binding */ syncIdea; },
/* harmony export */   "syncIdeas": function() { return /* binding */ syncIdeas; },
/* harmony export */   "updateContext": function() { return /* binding */ updateContext; },
/* harmony export */   "updateIdea": function() { return /* binding */ updateIdea; },
/* harmony export */   "updateIdeaOrder": function() { return /* binding */ updateIdeaOrder; },
/* harmony export */   "updateImage": function() { return /* binding */ updateImage; },
/* harmony export */   "updateTitle": function() { return /* binding */ updateTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var api_Article__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63719);
/* harmony import */ var api_Insight__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32209);
/* harmony import */ var types_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41390);
/* harmony import */ var types_models__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82260);
/* harmony import */ var _utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73810);









var deleteIdea = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var codeSource, idea, ref, ideaId, article;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    codeSource = param.codeSource, idea = param.idea;
                    ideaId = idea.id;
                    if (ideaId < 0) {
                        //This idea doesn't exist on the backend
                        //Just delete it from the UI
                        dispatch({
                            type: "delete-idea/success",
                            payload: {
                                ideaId: idea.id
                            }
                        });
                        return [
                            2
                        ];
                    }
                    article = null;
                    if (!ideaId) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .getArticleByInsightId */ .mH)(ideaId)
                    ];
                case 1:
                    article = _state.sent();
                    _state.label = 2;
                case 2:
                    if (article && article.status === types_enums__WEBPACK_IMPORTED_MODULE_2__/* .ArticleStatus.DRAFT */ .af.DRAFT || (article === null || article === void 0 ? void 0 : (ref = article.blocks) === null || ref === void 0 ? void 0 : ref.length) !== 1) {
                        //Deleting this idea shouldn't result in the deletion of the source
                        if (ideaId && ideaId > 0) (0,api_Insight__WEBPACK_IMPORTED_MODULE_1__/* .deleteInsight */ .QV)(ideaId, codeSource);
                        dispatch({
                            type: "delete-idea/success",
                            payload: {
                                ideaId: idea.id
                            }
                        });
                        return [
                            2
                        ];
                    }
                    //If we haven't returned yet, this is the last idea of a published article
                    // The whole source should be deleted
                    if (article) {
                        (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .deleteArticle */ .jX)(article.id);
                        // Also delete the ideas
                        if (ideaId && ideaId > 0) (0,api_Insight__WEBPACK_IMPORTED_MODULE_1__/* .deleteInsight */ .QV)(ideaId, codeSource);
                        dispatch({
                            type: "delete-idea/success",
                            payload: {
                                ideaId: idea.id
                            }
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteIdea(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Action to sync the local changes to an idea to the backend
 * If the idea doesn't yet exist on the backend, it will be created the first time this action gets dispatched
 * @param dispatch The dispatch function for the Source Provider
 * @param idea The fields of the idea that got updated.
 * If it's a creation, it's the whole idea.
 * The partial should always contain the localId to identify the idea locally
 * @param sourceId The source to which this idea belongs to
 * @param onSuccess A callback that is called after the creation/update was successful.
 * If it was a creation it will get the id of the idea as a parameter
 * @param userProfile The profile of the current user to use as the user_info for the newly created idea
 * @param updateTimestamp A timestamp for this update to ensure we don't overwrite updates with older ones
 */ var syncIdea = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var idea, sourceId, onSuccess, userProfile, updateTimestamp, onSyncSuccess, onSyncLoading, ref, reQueue, sourceCreated;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    idea = param.idea, sourceId = param.sourceId, onSuccess = param.onSuccess, userProfile = param.userProfile, updateTimestamp = param.updateTimestamp;
                    onSyncSuccess = function(ideaId, created_at, user, source) {
                        // If we don't have an id present in the Partial<Idea> to identify the idea there is nothing we can do with the returned data
                        if (!idea.id || !idea.localId) {
                            return;
                        }
                        if (created_at) {
                            //This was a creation
                            dispatch({
                                type: "sync-idea/success",
                                payload: {
                                    source: source,
                                    createdAt: created_at,
                                    id: ideaId,
                                    localIdeaId: idea.localId,
                                    userId: user ? Number.parseInt(user) : undefined
                                }
                            });
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(ideaId);
                        } else {
                            //This was update
                            dispatch({
                                type: "sync-idea/success",
                                payload: {
                                    localIdeaId: idea.localId
                                }
                            });
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        }
                    };
                    onSyncLoading = function() {
                        if (!idea.localId) {
                            return;
                        }
                        dispatch({
                            type: "sync-idea/loading",
                            payload: {
                                localIdeaId: idea.localId
                            }
                        });
                    };
                    return [
                        4,
                        (0,_utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_4__/* .syncIdeaUtil */ .LG)(idea, userProfile, sourceId, onSyncSuccess, onSyncLoading)
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), reQueue = ref[0], sourceCreated = ref[1];
                    if (reQueue) {
                        //This update can't be processed now, re-queue it
                        // The idea cast is not valid, but it has all the fields required for a re-queue since it came from the syncManager in the first place
                        _utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_4__/* .DebounceIdeaSyncManagerInstance.syncIdea */ .of.syncIdea(dispatch, idea, userProfile, updateTimestamp, sourceId);
                    }
                    return [
                        2,
                        sourceCreated
                    ];
            }
        });
    });
    return function syncIdea(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Action to sync a list of ideas to the backend at once
 * @param dispatch The source provider dispatch function
 * @param ideas The ideas we want to sync
 * @param sourceId The source those ideas belong to
 */ var syncIdeas = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var ideas, sourceId, onNewIdeaCreationSuccess, unsavedIdeasLocalIds, newIdeasData, collectNewIdeaData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, idea, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ideas = param.ideas, sourceId = param.sourceId, onNewIdeaCreationSuccess = param.onNewIdeaCreationSuccess;
                    unsavedIdeasLocalIds = [];
                    newIdeasData = new Map();
                    collectNewIdeaData = function(localIdeaId, id, created_at, user) {
                        // Collect the id and the created_at data for the idea with this localId in a map
                        newIdeasData.set(localIdeaId, {
                            created_at: created_at,
                            id: id,
                            user: user
                        });
                        onNewIdeaCreationSuccess === null || onNewIdeaCreationSuccess === void 0 ? void 0 : onNewIdeaCreationSuccess({
                            ideaId: id
                        });
                    };
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = ideas[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    idea = _step.value;
                    if (idea.syncStatus === types_models__WEBPACK_IMPORTED_MODULE_3__/* .IdeaSyncStatus.NOT_SYNCED */ .yv.NOT_SYNCED) {
                        unsavedIdeasLocalIds.push(idea.localId);
                    }
                    //Make a loading dispatch for the ideas that are just now created on the backend
                    dispatch({
                        type: "sync-ideas/loading",
                        payload: {
                            localIdeaIds: unsavedIdeasLocalIds
                        }
                    });
                    //Sync the ideas
                    return [
                        4,
                        (0,_utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_4__/* .syncIdeasUtil */ .o6)({
                            ideas: ideas,
                            sourceId: sourceId,
                            onSuccess: collectNewIdeaData
                        })
                    ];
                case 3:
                    _state.sent();
                    dispatch({
                        type: "sync-ideas/success",
                        payload: {
                            localIdeaIds: ideas.map(function(idea) {
                                return idea.localId;
                            }),
                            newIdeas: newIdeasData
                        }
                    });
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function syncIdeas(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Prior to 2023, this call could result in the creation of a draft
 * After the 2023 update, we always create a draft first,
 * so this is not the case anymore.
 */ var updateIdea = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var idea, newValue, sourceId, canIdeaAutosave, userProfile, changedProperties, updatedIdea;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    idea = param.idea, newValue = param.newValue, sourceId = param.sourceId, canIdeaAutosave = param.canIdeaAutosave, userProfile = param.userProfile;
                    changedProperties = Object.entries(newValue).reduce(function(acc, param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                        if (idea && idea[key] !== value) {
                            return acc + 1;
                        } else {
                            return acc;
                        }
                    }, 0);
                    // No properties changed
                    if (changedProperties === 0) return [
                        2
                    ];
                    if (!idea) return [
                        3,
                        2
                    ];
                    updatedIdea = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, idea, newValue);
                    dispatch({
                        type: "update-idea/success",
                        payload: {
                            localIdea: idea.localId,
                            newValue: newValue
                        }
                    });
                    if (!canIdeaAutosave) return [
                        3,
                        2
                    ];
                    //If the idea is already created on the backend, this will be a PATCH so send only the relevant bits
                    return [
                        4,
                        _utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_4__/* .DebounceIdeaSyncManagerInstance.syncIdea */ .of.syncIdea(dispatch, updatedIdea, userProfile, new Date(), sourceId, !(0,_utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_4__/* .isLocalIdea */ .Aj)(idea.id) ? newValue : undefined)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function updateIdea(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
var deleteDraft = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var activityDispatch, sourceId, ideaIds, isOpenedDraft;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            activityDispatch = param.activityDispatch, sourceId = param.sourceId, ideaIds = param.ideaIds, isOpenedDraft = param.isOpenedDraft;
            //Delete the source on the backend
            (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .deleteArticle */ .jX)(sourceId);
            // Also delete the ideas
            ideaIds.forEach(function(ideaId) {
                if (ideaId && ideaId > 0) (0,api_Insight__WEBPACK_IMPORTED_MODULE_1__/* .deleteInsight */ .QV)(ideaId, "draft-delete");
            });
            //Update the activity slice
            activityDispatch({
                type: "delete-draft/success",
                payload: {
                    id: sourceId
                }
            });
            if (isOpenedDraft) // We deleted the currently opened article so dispatch this action to clear the SourceProvider
            dispatch({
                type: "delete-draft/success"
            });
            return [
                2
            ];
        });
    });
    return function deleteDraft(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
var updateImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var sourceId, image;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sourceId = param.sourceId, image = param.image;
                    return [
                        4,
                        (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .updateArticleData */ .fc)({
                            sourceId: sourceId,
                            image: image
                        }).then(function() {
                            dispatch({
                                type: "update-image/success",
                                payload: {
                                    image: image
                                }
                            });
                            return Promise.resolve();
                        }).catch(function(e) {
                            console.log(e);
                            return Promise.reject(e);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function updateImage(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
var updateTitle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var sourceId, title;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sourceId = param.sourceId, title = param.title;
                    return [
                        4,
                        (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .updateArticleData */ .fc)({
                            sourceId: sourceId,
                            title: title
                        }).then(function() {
                            dispatch({
                                type: "update-title/success",
                                payload: {
                                    title: title
                                }
                            });
                            return Promise.resolve();
                        }).catch(function(e) {
                            console.log(e);
                            return Promise.reject(e);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function updateTitle(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
var updateContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var sourceId, context;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sourceId = param.sourceId, context = param.context;
                    return [
                        4,
                        (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .updateArticleData */ .fc)({
                            sourceId: sourceId,
                            context: context
                        }).then(function() {
                            dispatch({
                                type: "update-context/success",
                                payload: {
                                    context: context
                                }
                            });
                            return Promise.resolve();
                        }).catch(function(e) {
                            console.log(e);
                            return Promise.reject(e);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function updateContext(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();
var updateIdeaOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dispatch, param) {
        var sourceId, initialIdeasById, reorderedIdeasById, status;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sourceId = param.sourceId, initialIdeasById = param.initialIdeasById, reorderedIdeasById = param.reorderedIdeasById, status = param.status;
                    dispatch({
                        type: "update-idea-order/success",
                        payload: {
                            ideasById: reorderedIdeasById,
                            status: status
                        }
                    });
                    return [
                        4,
                        (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .reorderArticleInsights */ .Tk)({
                            sourceId: sourceId,
                            ideasById: reorderedIdeasById
                        }).then(function() {
                            return Promise.resolve();
                        }).catch(function(e) {
                            console.log("error updating idea order");
                            dispatch({
                                type: "update-idea-order/success",
                                payload: {
                                    ideasById: initialIdeasById,
                                    status: status
                                }
                            });
                            console.log(e);
                            return Promise.reject(e);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function updateIdeaOrder(dispatch, _) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 24718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var api_Article__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63719);
/* harmony import */ var types_enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41390);
/* harmony import */ var types_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82260);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var utils_idea_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21098);
/* harmony import */ var _utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73810);









var sourceReducer = function(state, action) {
    switch(action.type){
        case "create-idea":
            {
                var _Math;
                var _payload = action.payload, ideaStatus = _payload.ideaStatus, userId = _payload.userId, content = _payload.content, type = _payload.type;
                // Get the index of this idea
                var index = (_Math = Math).max.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.ideas.map(function(ideaObservable) {
                    return ideaObservable.Data.order;
                })).concat([
                    0, 
                ]));
                var ideas = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.ideas);
                var newIdeaId = utils_idea_utils__WEBPACK_IMPORTED_MODULE_4__/* .ideaIdManager.getId */ .DF.getId();
                ideas.push(new utils_global__WEBPACK_IMPORTED_MODULE_3__/* .Observable */ .y$({
                    content: content !== null && content !== void 0 ? content : "<p></p>",
                    createdAt: "",
                    // If the id is negative => the idea is locally created
                    // the id will become positive once the backend saved the idea
                    id: newIdeaId,
                    localId: newIdeaId,
                    order: index + 1,
                    topics: [],
                    totalSaves: 1,
                    totalReads: 0,
                    // [Like functionality]
                    // totalLikes: 0,
                    status: ideaStatus,
                    isDraft: true,
                    syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.NOT_SYNCED */ .yv.NOT_SYNCED,
                    timeToRead: 0,
                    title: "",
                    userId: userId,
                    type: type !== null && type !== void 0 ? type : types_enums__WEBPACK_IMPORTED_MODULE_1__/* .IdeaType.DEFAULT */ .Wm.DEFAULT
                }));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    ideas: ideas
                });
            }
        case "delete-idea/success":
            {
                var ideaId = action.payload.ideaId;
                var updatedIdeas = state.ideas.filter(function(ideaObservable) {
                    return ideaObservable.Data.id !== ideaId;
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    ideas: updatedIdeas
                });
            }
        case "sync-idea/loading":
            {
                var ref;
                var localIdeaId = action.payload.localIdeaId;
                (ref = state.ideas.find(function(idea) {
                    return idea.Data.localId === localIdeaId;
                })) === null || ref === void 0 ? void 0 : ref.updateData(function(_) {
                    return {
                        syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.SYNCING */ .yv.SYNCING
                    };
                });
                return state;
            }
        case "sync-idea/success":
            {
                //Update the state of the idea
                var _payload1 = action.payload, localIdeaId1 = _payload1.localIdeaId, id = _payload1.id, createdAt = _payload1.createdAt, userId1 = _payload1.userId, source = _payload1.source;
                var idea = state.ideas.find(function(idea) {
                    return idea.Data.localId === localIdeaId1;
                });
                if (idea) {
                    // Here we check the id since even after the idea got synced on the backend, the localId can still be negative
                    if (!(0,_utils_SourceProviderUtils__WEBPACK_IMPORTED_MODULE_5__/* .isLocalIdea */ .Aj)(idea.Data.id)) {
                        idea.updateData({
                            syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.SYNCED */ .yv.SYNCED
                        });
                    } else {
                        //The idea just got created on the backend so let's add the id to it
                        idea.updateData({
                            id: id,
                            localId: id,
                            createdAt: createdAt,
                            userId: userId1,
                            syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.SYNCED */ .yv.SYNCED
                        });
                    }
                }
                if (source) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                        source: source
                    });
                } else if (id) {
                    //When an idea gets the id from the backend we need to return a new state so the id change is handled correctly
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state);
                } else {
                    return state;
                }
            }
        case "toggle-is-idea-draft":
            {
                var localIdeaId2 = action.payload.localIdeaId;
                //Update the idea state
                var idea1 = state.ideas.find(function(idea) {
                    return idea.Data.localId === localIdeaId2;
                });
                idea1 === null || idea1 === void 0 ? void 0 : idea1.updateData({
                    isDraft: !idea1.Data.isDraft
                });
                return state;
            }
        case "update-idea/success":
            {
                var _payload2 = action.payload, localIdea = _payload2.localIdea, newValue = _payload2.newValue;
                //Update the idea
                var idea2 = state.ideas.find(function(idea) {
                    return idea.Data.localId === localIdea;
                });
                //This idea is now not synced to the backend
                idea2 === null || idea2 === void 0 ? void 0 : idea2.updateData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, newValue), {
                    syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.NOT_SYNCED */ .yv.NOT_SYNCED
                }));
                return state;
            }
        case "change-idea-type":
            {
                var _payload3 = action.payload, localIdeaId3 = _payload3.localIdeaId, ideaType = _payload3.ideaType;
                var idea3 = state.ideas.find(function(idea) {
                    return idea.Data.localId === localIdeaId3;
                });
                //Get the current type
                var isQuote = (idea3 === null || idea3 === void 0 ? void 0 : idea3.Data.type) === types_enums__WEBPACK_IMPORTED_MODULE_1__/* .IdeaType.QUOTE */ .Wm.QUOTE;
                idea3 === null || idea3 === void 0 ? void 0 : idea3.updateData({
                    authorName: isQuote ? undefined : "",
                    title: isQuote ? "" : idea3 === null || idea3 === void 0 ? void 0 : idea3.Data.title,
                    type: ideaType
                });
                return state;
            }
        case "sync-ideas/success":
            {
                var _payload4 = action.payload, localIdeaIds = _payload4.localIdeaIds, newIdeas = _payload4.newIdeas;
                var ideas1 = state.ideas.filter(function(param) {
                    var Data = param.Data;
                    return localIdeaIds.includes(Data.localId);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ideas1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var idea4 = _step.value;
                        if (newIdeas === null || newIdeas === void 0 ? void 0 : newIdeas.has(idea4.Data.localId)) {
                            //This idea was just created so let's update it accordingly
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            var ref1 = newIdeas.get(idea4.Data.localId), id1 = ref1.id, created_at = ref1.created_at, user = ref1.user;
                            idea4.updateData({
                                syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.SYNCED */ .yv.SYNCED,
                                id: id1,
                                createdAt: created_at,
                                userId: user ? Number.parseInt(user) : undefined
                            });
                        }
                        idea4.updateData({
                            syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.SYNCED */ .yv.SYNCED
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return state;
            }
        case "sync-ideas/loading":
            {
                var localIdeaIds1 = action.payload.localIdeaIds;
                var ideas2 = state.ideas.filter(function(param) {
                    var Data = param.Data;
                    return localIdeaIds1.includes(Data.localId);
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = ideas2[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var idea5 = _step1.value;
                        idea5.updateData({
                            syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.SYNCING */ .yv.SYNCING
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return state;
            }
        case "publish-source/success":
            {
                if (!state.source) {
                    return state;
                }
                var stash = action.payload.stash;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    //Mark all ideas as not drafts
                    for(var _iterator2 = state.ideas[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var idea6 = _step2.value;
                        idea6.updateData({
                            isDraft: false
                        });
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    source: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.source), {
                        status: types_enums__WEBPACK_IMPORTED_MODULE_1__/* .ArticleStatus.PUBLISHED */ .af.PUBLISHED,
                        publishStash: stash
                    })
                });
            }
        case "set-context-editor-ref":
            {
                var contextEditorRef = action.payload.contextEditorRef;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    sourceContextEditorRef: contextEditorRef
                });
            }
        case "set-title-editor-ref":
            {
                var titleEditorRef = action.payload.titleEditorRef;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    sourceTitleEditorRef: titleEditorRef
                });
            }
        case "set-source":
            {
                var source1 = action.payload.source;
                if (source1) {
                    var ref2;
                    var ref3;
                    //This is an already existing source so load the ideas
                    return {
                        source: source1,
                        //Init the local properties of ideas
                        ideas: source1.ideas.map(function(idea) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, idea), {
                                autoSave: source1.status === types_enums__WEBPACK_IMPORTED_MODULE_1__/* .ArticleStatus.DRAFT */ .af.DRAFT,
                                draftFocus: false,
                                isDraft: source1.status === types_enums__WEBPACK_IMPORTED_MODULE_1__/* .ArticleStatus.DRAFT */ .af.DRAFT,
                                localId: idea.id,
                                syncStatus: types_models__WEBPACK_IMPORTED_MODULE_2__/* .IdeaSyncStatus.SYNCED */ .yv.SYNCED
                            });
                        }).map(function(idea) {
                            return new utils_global__WEBPACK_IMPORTED_MODULE_3__/* .Observable */ .y$(idea);
                        }),
                        sourceHashtags: (ref3 = (ref2 = source1.ideas[0]) === null || ref2 === void 0 ? void 0 : ref2.hashtags) !== null && ref3 !== void 0 ? ref3 : []
                    };
                } else {
                    // We return an empty state for when going back to the empty draft page
                    return {
                        source: null,
                        ideas: [],
                        sourceHashtags: []
                    };
                }
            }
        case "update-idea-order/success":
            {
                if (!state.source) {
                    return state;
                }
                var ideasById = action.payload.ideasById;
                var sortedIdeasList = state.ideas.map(function(idea) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, idea.Data), {
                        order: ideasById.indexOf(idea.Data.id) + 1
                    });
                });
                sortedIdeasList.sort(function(a, b) {
                    return a.order - b.order;
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    ideas: sortedIdeasList.map(function(idea) {
                        return new utils_global__WEBPACK_IMPORTED_MODULE_3__/* .Observable */ .y$(idea);
                    })
                });
            }
        case "update-image/success":
            {
                if (!state.source) return state;
                var image = action.payload.image;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    source: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.source), {
                        image: image
                    })
                });
            }
        case "update-context/success":
            {
                if (!state.source) {
                    return state;
                }
                var context = action.payload.context;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    source: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.source), {
                        context: context
                    })
                });
            }
        case "update-title/success":
            {
                if (!state.source) {
                    return state;
                }
                var title = action.payload.title;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    source: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.source), {
                        title: title
                    })
                });
            }
        case "update-independent-source":
            {
                if (!state.source) {
                    return state;
                }
                var _payload5 = action.payload, title1 = _payload5.title, description = _payload5.description;
                (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .updateIndependentArticle */ .dB)(state.source.id, title1, description);
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    source: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.source), {
                        title: title1,
                        description: description
                    })
                });
            }
        case "delete-draft/success":
            {
                return {
                    source: null,
                    ideas: [],
                    sourceHashtags: [],
                    focusedDraft: undefined
                };
            }
        case "import-source/success":
            {
                var source2 = action.payload.source;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    source: source2
                });
            }
        case "set-focused-draft":
            {
                var _payload6 = action.payload, isFocused = _payload6.isFocused, localIdeaId4 = _payload6.localIdeaId;
                if (isFocused) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                        focusedDraft: localIdeaId4
                    });
                } else if (state.focusedDraft === localIdeaId4) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                        focusedDraft: undefined
                    });
                } else return state;
            }
        case "update-source-hashtags":
            {
                if (!state.source) {
                    return state;
                }
                var hashtags = action.payload.hashtags;
                //We don't need anything from the API
                (0,api_Article__WEBPACK_IMPORTED_MODULE_0__/* .updateSourceHashtags */ .Hw)(hashtags, state.source.id);
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = state.ideas[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var idea7 = _step3.value;
                        idea7.updateData({
                            hashtags: hashtags
                        });
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    sourceHashtags: hashtags
                });
            }
        case "update-valid-ideas-count":
            {
                var validIdeasCount = action.payload.validIdeasCount;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    validIdeasCount: validIdeasCount
                });
            }
        default:
            {
                return state;
            }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (sourceReducer);


/***/ }),

/***/ 73810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$m": function() { return /* binding */ isIdeaAiEligible; },
/* harmony export */   "Aj": function() { return /* binding */ isLocalIdea; },
/* harmony export */   "LG": function() { return /* binding */ syncIdeaUtil; },
/* harmony export */   "Z2": function() { return /* binding */ isIdeaEmpty; },
/* harmony export */   "o6": function() { return /* binding */ syncIdeasUtil; },
/* harmony export */   "of": function() { return /* binding */ DebounceIdeaSyncManagerInstance; }
/* harmony export */ });
/* unused harmony export getCreationPayload */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_class_private_field_get_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4022);
/* harmony import */ var _swc_helpers_src_class_private_field_init_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70222);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var api_Insight__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32209);
/* harmony import */ var types_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82260);
/* harmony import */ var utils_html_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77757);
/* harmony import */ var _SourceEditorActions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32425);
/* harmony import */ var api_Article__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63719);
/* harmony import */ var utils_normalizers_source__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27079);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3620);
/* harmony import */ var utils_idea_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21098);















var _content, _type;
/**
 * Create the payload for the idea creation API call
 * @param creationSourceId The id of the source of this idea
 * @param idea The contents of the idea
 */ var getCreationPayload = function(creationSourceId, idea) {
    return {
        articleId: creationSourceId,
        authorName: idea.authorName,
        content: (_content = idea.content) !== null && _content !== void 0 ? _content : "",
        image: idea.image,
        order: idea.order,
        quality: idea.quality,
        status: idea.status,
        title: idea.title,
        type: (_type = idea.type) !== null && _type !== void 0 ? _type : types__WEBPACK_IMPORTED_MODULE_6__/* .IdeaType.DEFAULT */ .Wm.DEFAULT
    };
};
/**
 * Makes the appropriate API call to sync the idea to the backend
 * @param idea The idea to be synced. Should always contain the localId of the idea, the id and it's creation status
 * If it's a creation it should be the whole local idea
 * It should have both the id and the local id whether it's an update or a creation to properly determine which one it is
 * @param sourceId The id of the source of the idea
 * @param onSuccess A callback to be made after the api calls. The params of the callback are the API response for idea creation.
 * If this is edit, only the ideaId will be echoed back
 * If this sync resulted in the creation of an UNKNOWN source, it will be returned through the respective param in the callback
 * @param onLoading A callback to signal the start of an API call
 * @return A pair holding True on the first position if the update should be re-queued
 * and True on the second position if a source was created
 */ var syncIdeaUtil = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(idea, userProfile, sourceId, onSuccess, onLoading) {
        var localIdeaId, ideaId, _content, ref, id, created_at, user, sourceApiResponse, source, ref1, id1, created_at1, user1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    localIdeaId = idea.localId;
                    ideaId = idea.id;
                    if (!(localIdeaId !== undefined && ideaId !== undefined)) return [
                        3,
                        8
                    ];
                    if (!!isLocalIdea(ideaId)) return [
                        3,
                        2
                    ];
                    // It exists on the backend so it's an update
                    onLoading === null || onLoading === void 0 ? void 0 : onLoading();
                    return [
                        4,
                        (0,api_Insight__WEBPACK_IMPORTED_MODULE_0__/* .editInsight */ .Rj)(ideaId, idea)
                    ];
                case 1:
                    _state.sent();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(ideaId);
                    return [
                        3,
                        8
                    ];
                case 2:
                    if (!(idea.syncStatus === types_models__WEBPACK_IMPORTED_MODULE_1__/* .IdeaSyncStatus.SYNCING */ .yv.SYNCING)) return [
                        3,
                        3
                    ];
                    //A request is in progress. Don't do anything
                    // Return that we should requeue this update to not lose data
                    return [
                        2,
                        [
                            true,
                            false
                        ]
                    ];
                case 3:
                    if (!((idea.type === types__WEBPACK_IMPORTED_MODULE_6__/* .IdeaType.IMAGE */ .Wm.IMAGE && !!idea.image || idea.type !== types__WEBPACK_IMPORTED_MODULE_6__/* .IdeaType.IMAGE */ .Wm.IMAGE && (0,utils_html_utils__WEBPACK_IMPORTED_MODULE_2__/* .ideaHasContent */ .qx)((_content = idea.content) !== null && _content !== void 0 ? _content : "")) && utils_idea_utils__WEBPACK_IMPORTED_MODULE_7__/* .ideaIdManager.canPostId */ .DF.canPostId(localIdeaId))) return [
                        3,
                        8
                    ];
                    // So this is a creation
                    // The idea has content in it and it's the first time we make a request to create an idea on the backend with this local id. Thus we can proceed
                    //The api request to create the idea will soon be initiated, so set the loading state
                    onLoading === null || onLoading === void 0 ? void 0 : onLoading();
                    //Mark this idea as created on the backend to not send another POST
                    utils_idea_utils__WEBPACK_IMPORTED_MODULE_7__/* .ideaIdManager.markIdAsPosted */ .DF.markIdAsPosted(localIdeaId);
                    if (!sourceId) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0,api_Insight__WEBPACK_IMPORTED_MODULE_0__/* .createInsight */ .eL)(getCreationPayload(sourceId, idea))
                    ];
                case 4:
                    ref = _state.sent(), id = ref.id, created_at = ref.created_at, user = ref.user;
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(id, created_at, user);
                    return [
                        3,
                        8
                    ];
                case 5:
                    return [
                        4,
                        (0,api_Article__WEBPACK_IMPORTED_MODULE_4__/* .createUnknownSource */ .gm)()
                    ];
                case 6:
                    sourceApiResponse = _state.sent();
                    source = (0,utils_normalizers_source__WEBPACK_IMPORTED_MODULE_5__/* .normalizeUnknownSource */ .jW)(sourceApiResponse, userProfile);
                    return [
                        4,
                        (0,api_Insight__WEBPACK_IMPORTED_MODULE_0__/* .createInsight */ .eL)(getCreationPayload(source.id, idea))
                    ];
                case 7:
                    ref1 = _state.sent(), id1 = ref1.id, created_at1 = ref1.created_at, user1 = ref1.user;
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(id1, created_at1, user1, source);
                    return [
                        2,
                        [
                            false,
                            true
                        ]
                    ];
                case 8:
                    return [
                        2,
                        [
                            false,
                            false
                        ]
                    ];
            }
        });
    });
    return function syncIdeaUtil(idea, userProfile, sourceId, onSuccess, onLoading) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Makes the appropriate API call to sync a list of ideas to the backend
 * @param ideas The ideas to be synced
 * @param sourceId The id of the source of the idea
 * @param onSuccess A callback to be made after the creation api calls.
 * This callback is called for each created ideas. The params of the callback are the API response for idea creation.
 */ var syncIdeasUtil = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var ideas, sourceId, onSuccess, ideasToEdit, ideasToCreate, ideasToCreateLocalIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, idea, blocks, i, _i, id, created_at, user, key;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ideas = param.ideas, sourceId = param.sourceId, onSuccess = param.onSuccess;
                    ideasToEdit = [];
                    ideasToCreate = [];
                    ideasToCreateLocalIds = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = ideas[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            idea = _step.value;
                            if (!isLocalIdea(idea.id)) {
                                // This idea already exists on the backend so this is an update
                                ideasToEdit.push(idea);
                            } else if ((idea.type === types__WEBPACK_IMPORTED_MODULE_6__/* .IdeaType.IMAGE */ .Wm.IMAGE && !!idea.image || idea.type !== types__WEBPACK_IMPORTED_MODULE_6__/* .IdeaType.IMAGE */ .Wm.IMAGE && (0,utils_html_utils__WEBPACK_IMPORTED_MODULE_2__/* .ideaHasContent */ .qx)(idea.content)) && utils_idea_utils__WEBPACK_IMPORTED_MODULE_7__/* .ideaIdManager.canPostId */ .DF.canPostId(idea.localId)) {
                                // if it's a local idea but has content => add in creation queue
                                utils_idea_utils__WEBPACK_IMPORTED_MODULE_7__/* .ideaIdManager.markIdAsPosted */ .DF.markIdAsPosted(idea.localId);
                                ideasToCreate.push(idea);
                                ideasToCreateLocalIds.push(idea.localId);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!(ideasToCreate.length !== 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api_Insight__WEBPACK_IMPORTED_MODULE_0__/* .createMultipleIdeas */ .IT)(sourceId, ideasToCreate)
                    ];
                case 1:
                    blocks = _state.sent().blocks;
                    //Make the callback for all newly created ideas
                    for(i = 0; i < blocks.length; i++){
                        _i = blocks[i], id = _i.id, created_at = _i.created_at, user = _i.user;
                        key = ideasToCreateLocalIds[i];
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(key, id, created_at, user);
                    }
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0,api_Insight__WEBPACK_IMPORTED_MODULE_0__/* .editMultipleIdeas */ .uh)(ideasToEdit)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function syncIdeasUtil(_) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Function that determines if an idea is untouched
 * (no author, no title, no image, no content)
 * @param idea checked idea
 * @returns boolean
 */ var isIdeaEmpty = function(idea) {
    return (idea.title === "" || !idea.title) && (idea.authorName === "" || !idea.authorName) && !(0,utils_html_utils__WEBPACK_IMPORTED_MODULE_2__/* .ideaHasContent */ .qx)(idea.content) && (!idea.image || idea.image === "");
};
/**
 * Function that determines if an idea can be sent to the AI
 * (i.e. if it is a text-type idea and it has at least a title or content)
 * @param idea checked idea
 * @returns boolean
 */ var isIdeaAiEligible = function(idea) {
    var ref;
    var ref1;
    return (((ref1 = (ref = idea.title) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0 || (0,utils_html_utils__WEBPACK_IMPORTED_MODULE_2__/* .ideaHasContent */ .qx)(idea.content)) && idea.type === types__WEBPACK_IMPORTED_MODULE_6__/* .IdeaType.DEFAULT */ .Wm.DEFAULT;
};
/**
 * Checks if an idea is just on local
 * @param ideaId id of the checked idea
 */ var isLocalIdea = function(ideaId) {
    // if the id is negative => the idea wasn't sent to the backend
    return ideaId < 0;
};
var _queuedSyncRequests = /*#__PURE__*/ new WeakMap();
/**
 * A class that handles idea syncing
 * We want the saves to be debounced,
 * but if multiple sync requests for multiple ideas hit at the same time we don't want any of them do be dropped
 */ var DebounceIdeaSyncManager = /*#__PURE__*/ function() {
    "use strict";
    function DebounceIdeaSyncManager() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(this, DebounceIdeaSyncManager);
        /**
   * Maps idea keys to debounced sync requests
   */ (0,_swc_helpers_src_class_private_field_init_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, _queuedSyncRequests, {
            writable: true,
            value: new Map()
        });
    }
    var _proto = DebounceIdeaSyncManager.prototype;
    /**
   * Queues a sync request
   * If there was already a request made to sync this idea, the old one will be dropped and replaced with the new one
   * @param dispatch The dispatch function for the SourceProvider
   * @param idea The idea to be synced
   * @param sourceId The id of the source
   * @param patchedIdea When updating an idea already created we should send only the fields that changed. Provide those changes in this param
   * If this is a creation, this should be undefined since we have to send the full idea when creating it
   * @return A promise that resolves to whether or not a draft was created on the backend for this sync
   */ _proto.syncIdea = function syncIdea1(dispatch, idea, userProfile, updateTimestamp, sourceId, patchedIdea) {
        var _this = this;
        return new Promise(function(resolve) {
            var prevPendingUpdate = (0,_swc_helpers_src_class_private_field_get_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_this, _queuedSyncRequests).get(idea.id);
            var fieldsToUpdate = {};
            if (prevPendingUpdate && prevPendingUpdate.timestamp < updateTimestamp) {
                // If there is already a pending update for this idea, drop it
                // Load the fields to be sent to the backend from the previous update
                fieldsToUpdate = prevPendingUpdate.patchedData ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prevPendingUpdate.patchedData) : {};
                clearTimeout(prevPendingUpdate.timeout);
            }
            // Update the fields to be sent to the backend with the latest ones
            fieldsToUpdate = patchedIdea ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, fieldsToUpdate, patchedIdea) : fieldsToUpdate;
            var timeoutId = setTimeout(function() {
                var draftCreated = (0,_SourceEditorActions__WEBPACK_IMPORTED_MODULE_3__.syncIdea)(dispatch, {
                    idea: Object.keys(fieldsToUpdate).length ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, fieldsToUpdate), {
                        id: idea.id,
                        localId: idea.localId,
                        syncStatus: idea.syncStatus
                    }) : idea,
                    sourceId: sourceId,
                    userProfile: userProfile,
                    updateTimestamp: updateTimestamp
                });
                resolve(draftCreated);
            }, 1300);
            (0,_swc_helpers_src_class_private_field_get_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_this, _queuedSyncRequests).set(idea.id, {
                timeout: timeoutId,
                timestamp: updateTimestamp,
                patchedData: fieldsToUpdate
            });
        });
    };
    return DebounceIdeaSyncManager;
}();
var DebounceIdeaSyncManagerInstance = new DebounceIdeaSyncManager();


/***/ }),

/***/ 21098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DF": function() { return /* binding */ ideaIdManager; },
/* harmony export */   "Fp": function() { return /* binding */ getValidIdeaCount; },
/* harmony export */   "XU": function() { return /* binding */ isIdeaInvalid; },
/* harmony export */   "l3": function() { return /* binding */ getSourceDraftsError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3620);
/* harmony import */ var utils_html_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77757);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14531);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);





/**
 * Check if the idea is valid (it has content within the limits and author if quote)
 */ var isIdeaInvalid = function(idea) {
    if (idea.type === types__WEBPACK_IMPORTED_MODULE_0__/* .IdeaType.IMAGE */ .Wm.IMAGE) {
        return !idea.image;
    }
    //Get the length of the plain text content
    var content = (0,utils_html_utils__WEBPACK_IMPORTED_MODULE_1__/* .stripHTMLTags */ .ox)(idea.content);
    //Invalid content length
    if (content.length === 0 || content.length > utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_LENGTH_LIMIT */ .lm) {
        return true;
    }
    //Last check. If author_name is an empty string it means it's a quote without an author
    return idea.type === types__WEBPACK_IMPORTED_MODULE_0__/* .IdeaType.QUOTE */ .Wm.QUOTE && !idea.authorName;
};
/**
 * Gets the number of valid ideas using invalidIdea function
 * @param ideas List of Ideas you want to check
 * @returns number of valid ideas
 */ var getValidIdeaCount = function(param) {
    var ideas = param.ideas, ideaObservables = param.ideaObservables;
    if (ideas) {
        var validIdeas = ideas.reduce(function(acc, idea) {
            if (isIdeaInvalid(idea)) {
                return acc;
            } else {
                return acc + 1;
            }
        }, 0);
        return validIdeas;
    } else if (ideaObservables) {
        var validIdeas1 = ideaObservables.reduce(function(acc, idea) {
            if (isIdeaInvalid(idea.Data)) {
                return acc;
            } else {
                return acc + 1;
            }
        }, 0);
        return validIdeas1;
    } else return 0;
};
/**
 * function that decides what error toast should be shown when pressing the disabled publish button
 * @param ideas the ideas inside the source
 * @param source the source to be published
 * @returns DraftsError type
 */ var getSourceDraftsError = function(ideas, source) {
    if (!source || source.sourceType === types__WEBPACK_IMPORTED_MODULE_0__/* .SourceType.UNKNOWN */ .PO.UNKNOWN) {
        return types__WEBPACK_IMPORTED_MODULE_0__/* .DraftsError.NO_SOURCE */ .ry.NO_SOURCE;
    }
    if (source.title === "") {
        return types__WEBPACK_IMPORTED_MODULE_0__/* .DraftsError.NO_TITLE */ .ry.NO_TITLE;
    }
    var error = undefined;
    var emptyIdeas = ideas.filter(function(idea) {
        return idea.Data.type !== types__WEBPACK_IMPORTED_MODULE_0__/* .IdeaType.IMAGE */ .Wm.IMAGE ? !(0,utils_html_utils__WEBPACK_IMPORTED_MODULE_1__/* .ideaHasContent */ .qx)(idea.Data.content) : !idea.Data.image;
    }).length;
    if (emptyIdeas === ideas.length) {
        return types__WEBPACK_IMPORTED_MODULE_0__/* .DraftsError.NO_IDEAS */ .ry.NO_IDEAS;
    }
    ideas.map(function(param) {
        var idea = param.Data;
        return idea;
    }).forEach(function(idea) {
        var ref;
        // optimize the function. once an error is chosen, don't bother continue checking
        if (error !== undefined) return;
        if (idea.type === types__WEBPACK_IMPORTED_MODULE_0__/* .IdeaType.IMAGE */ .Wm.IMAGE && !idea.image || idea.type !== types__WEBPACK_IMPORTED_MODULE_0__/* .IdeaType.IMAGE */ .Wm.IMAGE && !(0,utils_html_utils__WEBPACK_IMPORTED_MODULE_1__/* .ideaHasContent */ .qx)(idea.content)) {
            error = types__WEBPACK_IMPORTED_MODULE_0__/* .DraftsError.NO_CONTENT */ .ry.NO_CONTENT;
            return;
        }
        if (idea.type === types__WEBPACK_IMPORTED_MODULE_0__/* .IdeaType.QUOTE */ .Wm.QUOTE && ((ref = idea.authorName) === null || ref === void 0 ? void 0 : ref.trim()) === "") {
            error = types__WEBPACK_IMPORTED_MODULE_0__/* .DraftsError.NO_AUTHOR */ .ry.NO_AUTHOR;
            return;
        }
        if ((0,utils_html_utils__WEBPACK_IMPORTED_MODULE_1__/* .stripHTMLTags */ .ox)(idea.content).length > utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_LENGTH_LIMIT */ .lm) {
            error = types__WEBPACK_IMPORTED_MODULE_0__/* .DraftsError.CHARS_LIMIT */ .ry.CHARS_LIMIT;
            return;
        }
    });
    if (error === undefined) {
        error = types__WEBPACK_IMPORTED_MODULE_0__/* .DraftsError.NO_ERROR */ .ry.NO_ERROR;
    }
    return error;
};
var IdeaIdManager = function IdeaIdManager() {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, IdeaIdManager);
    //Keep track of all assigned local ids so far
    // When we send the create req to the backend, the id is marked as posted
    this._ids = {};
    this.getId = function() {
        while(true){
            var id = (0,_global__WEBPACK_IMPORTED_MODULE_3__/* .getRandomNegativeInt */ ._T)();
            if (!_this._ids[id]) {
                _this._ids[id] = "registered";
                return id;
            }
        }
    };
    this.markIdAsPosted = function(id) {
        if (id) {
            _this._ids[id] = "posted";
        }
    };
    this.canPostId = function(id) {
        return id && _this._ids[id] === "registered";
    };
};
var ideaIdManager = new IdeaIdManager();


/***/ }),

/***/ 11706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"preload":"FlipCorner_preload__gkUX2","unsaved_top_right":"FlipCorner_unsaved_top_right___KIG_","unsaved_top_right_animation":"FlipCorner_unsaved_top_right_animation__F0JG_","saved_top_right":"FlipCorner_saved_top_right__TtKIF","saved_top_right_animation":"FlipCorner_saved_top_right_animation__KJq2q","unsaved_bottom_left":"FlipCorner_unsaved_bottom_left__6uetd","unsaved_bottom_left_animation":"FlipCorner_unsaved_bottom_left_animation__LdrTU","saved_bottom_left":"FlipCorner_saved_bottom_left__OgxQR","saved_bottom_left_animation":"FlipCorner_saved_bottom_left_animation__6aGvA","initial_saved_bottom_left":"FlipCorner_initial_saved_bottom_left__C6AMh","initial_saved_top_right":"FlipCorner_initial_saved_top_right__IruYL","initial_unsaved_bottom_left":"FlipCorner_initial_unsaved_bottom_left__gKEzv","initial_unsaved_top_right":"FlipCorner_initial_unsaved_top_right__ctDbd"};

/***/ }),

/***/ 17630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"next_image_quote":"IdeaCard_next_image_quote__Qv6IA","next_image_idea":"IdeaCard_next_image_idea__aHc5q"};

/***/ })

}]);